import React, { useState, useContext } from "react";
import { Context } from "../store/appContext";
import getApiBaseUrl from "../utils/api";

const API_URL = getApiBaseUrl();

const UserForm = ({ onUserCreated }) => {
  const { store, actions } = useContext(Context);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [role, setRole] = useState("user");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !email || !password) {
      actions.showToast("Todos los campos son obligatorios", "error");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/users/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + store.token,
        },
        body: JSON.stringify({
          username,
          email,
          password,
          role,
        }),
      });

      const error = await actions.handleApiError(response);
      if (error) return;

      const data = await response.json();

      if (response.ok) {
        actions.showToast("Usuario creado correctamente", "success");

        setUsername("");
        setEmail("");
        setPassword("");
        setRole("user");

        if (onUserCreated) {
          onUserCreated();
        }
      } else {
        actions.showToast(data.msg || "Error al crear el usuario", "error");
      }
    } catch (error) {
      console.error(error);
      actions.showToast("Error del servidor", "error");
    }
  };

  return (
    <div className="admin-form-container">
      <div className="admin-form-card">
        <h4 className="mb-4 text-center">Crear usuario</h4>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Usuario</label>
            <input
              type="text"
              name="username"
              autoComplete="username"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label>Correo electrónico</label>
            <input
              type="email"
              name="email"
              autoComplete="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label>Contraseña</label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                autoComplete="new-password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={
                  showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
                }
              >
                <i
                  className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                ></i>
              </button>
            </div>
          </div>

          <div className="mb-3">
            <label>Rol</label>
            <select
              className="form-select"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="user">invitado</option>
              <option value="admin">Admin</option>
              <option value="tecnico">Técnico</option>
              <option value="scanner">Operador escaneo</option>
            </select>
          </div>

          <button className="btn btn-success w-100">Crear usuario</button>
        </form>
      </div>
    </div>
  );
};

export default UserForm;
